export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-primary-100/80 px-4 py-2 rounded-full mb-5">
            <i className="ri-mail-send-line text-primary-600 text-sm"></i>
            <span className="text-primary-700 text-xs font-medium">投稿 &amp; 咨询</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
            联系我们
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-lg mx-auto mb-8">
            有想推荐的超清大片？对4K画质观影体验有建议？欢迎通过以下方式联系麻花影院团队，我们珍视每一位影迷的声音。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-3 bg-background-50 border border-background-200/70 rounded-xl px-6 py-4 w-full sm:w-auto">
              <div className="w-11 h-11 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-wechat-line text-primary-600 text-xl"></i>
              </div>
              <div className="text-left">
                <div className="text-foreground-900 font-semibold text-sm">官方公众号</div>
                <div className="text-foreground-500 text-xs">麻花影院观影指南</div>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-background-50 border border-background-200/70 rounded-xl px-6 py-4 w-full sm:w-auto">
              <div className="w-11 h-11 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-accent-600 text-xl"></i>
              </div>
              <div className="text-left">
                <div className="text-foreground-900 font-semibold text-sm">投稿邮箱</div>
                <div className="text-foreground-500 text-xs">submit@mahuayingyuan.com</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}